import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AffiliateAppSuggestionDialogComponent } from 'src/@order/dialogs/affiliate-app-suggestion-dialog/affiliate-app-suggestion-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { DeviceDetectorService } from 'src/@order/services/device-detector.service';
import {
  ghanaWhatsAppLink,
  nigeriaWhatsAppLink,
} from 'src/app/utils/systemEnums';

@Component({
  selector: 'app-affiliate-redirection',
  templateUrl: './affiliate-redirection.component.html',
  styleUrls: ['./affiliate-redirection.component.scss'],
})
export class AffiliateRedirectionComponent implements OnInit {
  isDataLoading: boolean = true;
  affData;
  affiliateId;
  errorMessage: string;
  constructor(
    private _auth: AuthServiceLocal,
    private _deviceService: DeviceDetectorService,
    private _activatedRoute: ActivatedRoute,
    private _matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this._activatedRoute.params.subscribe((paramsData: any) => {
      console.log('paramsData', paramsData?.affiliateId);
      if (paramsData?.affiliateId) {
        this.affiliateId = Number(
          this.base64UrlEncode(String(paramsData?.affiliateId))
        );
        this.getAffiliateData({ affiliateId: this.affiliateId });
      }
    });
  }

  base64UrlEncode(str) {
    try {
      // Attempt to decode the string
      const decoded = atob(atob(decodeURIComponent(str)));
      return decoded;
    } catch (error) {
      this.isDataLoading = false;
      this.affData = null;
      this.errorMessage = "The affiliate link you are trying to use for registering on Phlenu does not contain a valid affiliate ID. Please contact your affiliate link provider to get the correct link."
      return "";
    }
  }

  getAffiliateData(body) {
    this._auth.getAffiliateUserData(body).subscribe((res) => {
      if (res.response == 1) {
        this.affData = res.data;
      } else {
        this.affData = null;
        this.errorMessage = res.message;
      }
      this.isDataLoading = false;
    });
  }

  onWabApp() {
    
    window.open(this.affData.webAffiliateLink, '_black');
  }

  onWhatsapp() {
    this._auth.increaseWhatsappCount({affiliateId : this.affiliateId}).subscribe((res)=>{
      console.log("res", res);
    })
    if (this.affData?.country == 'nigeria') {
      window.open(`https://wa.me/2349166329008?text=Hello%20there!%20%F0%9F%98%8A%0A%0AThanks%20for%20clicking%20your%20affiliate%20link.%20Here%E2%80%99s%20your%20unique%20affiliate%20code%20%F0%9F%91%89%F0%9F%8F%BE%20?affiliateId=${this.affiliateId}.%0A%0AHit%20the%20%E2%80%9CSend%E2%80%9D%20button%20to%20get%20started.` , '_black');
    } else { 
      window.open( `https://wa.me/233530460178?text=Hello%20there!%20%F0%9F%98%8A%0A%0AThanks%20for%20clicking%20your%20affiliate%20link.%20Here%E2%80%99s%20your%20unique%20affiliate%20code%20%F0%9F%91%89%F0%9F%8F%BE%20?affiliateId=${this.affiliateId}.%0A%0AHit%20the%20%E2%80%9CSend%E2%80%9D%20button%20to%20get%20started.` , '_black');
    }
  }

  onApp(link) {
    // first we need to check device info to show warning popup.
    if (this._deviceService.isMobile()) {

      console.log('App is open on a Mobile Device');
      window.open(link, '_black');

    } else if (this._deviceService.isTablet()) {

      console.log('App is open on a Tablet');
      window.open(link, '_black');

    } else {

      console.log('App is open on a Desktop Device');
      // need to show popup warning
      this.openSuggestionDialog();
      
    }
  }

  openSuggestionDialog() {
    this._matDialog.open(AffiliateAppSuggestionDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '610px',
      data: {
        affData: this.affData,
      },
    });
  }
}
